import React from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { useCurrentActor } from 'components/contexts/CurrentActor';
import { useProjectActivityContext } from 'components/contexts/ProjectActivityContext';
import ActivityTableHeaders from 'components/projectActivity/components/ActivityTableHeaders';

export default function ProjectActivityBlankNotice() {
  const {
    division: {
      attributes: { singularRAMSName },
    },
  } = useCurrentActor();

  const { editProjectPath, projectPolicy } = useProjectActivityContext();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'projectActivity.components.ProjectActivityBlankNotice',
  });

  return (
    <>
      <table className='table handshq__table handshq__table--spaced handshq__table--middled handshq__table--no-top-border handshq__table--no-bottom-border tw-border-grey-100'>
        <thead className='handshq__thead'>
          <ActivityTableHeaders />
        </thead>
      </table>
      <section className='section section--notice tw-border-grey-100 tw-bg-white tw-px-20'>
        <h2 className='section__header tw-pt-0 tw-text-l tw-font-semibold tw-text-grey-900'>
          {i18nT('title', {
            interpolation: { escapeValue: false },
            singularRAMSName,
          })}
        </h2>
        {projectPolicy.canUpdate && (
          <p className='section__content section__content-link tw-mb-0 tw-mt-2'>
            <Trans
              components={{
                a: (
                  /* eslint-disable jsx-a11y/anchor-has-content */
                  <a
                    className='app-link tw-align-baseline tw-text-blue-500 hover:tw-text-blue-300 active:tw-text-blue-300'
                    href={editProjectPath}
                  />
                  /* eslint-enable jsx-a11y/anchor-has-content */
                ),
              }}
              i18nKey='projectActivity.components.ProjectActivityBlankNotice.description'
              ns='components'
              tOptions={{ interpolation: { escapeValue: false } }}
              values={{ singularRAMSName }}
            />
          </p>
        )}
      </section>
    </>
  );
}
